import { FilterFieldOption, ColumnConfig } from '../../shared/types/lookup-screen.types';

export const FAX_AUDIT_FILTER_FIELDS: FilterFieldOption[] = [
  { label: 'All Fields', value: 'all' },
  { label: 'Account ID', value: 'accountIdNumeric' },
  { label: 'Client Type', value: 'clientTypeDecoded' },
  { label: 'Fax Type', value: 'faxType' },
] as const;

export const FAX_AUDIT_COLUMNS: ColumnConfig[] = [
  { key: 'accountIdNumeric', label: 'Account id', visible: true },
  { key: 'clientTypeDecoded', label: 'Client type', visible: true },
  { key: 'faxType', label: 'Fax type', visible: true },
] as const;

export const FAX_AUDIT_DEFAULT_PAGE_SIZE = 20;
export const FAX_AUDIT_PAGE_SIZE_OPTIONS: number[] = [10, 20, 50, 100];

export const FAX_AUDIT_MESSAGES = {
  SELECT_DOMAINS: 'Select the domains to retrieve fax information for',
  GET_INFORMATION: 'Get fax information for domain',
  UPDATE_ACCOUNTS: 'Update information for selected accounts',
  NO_ACCOUNTS: 'No accounts found',
  ALL_UPDATED: 'All users were updated',
  SOME_FAILED: 'Some users were not updated',
} as const;
